import { CardContent as Mui4CardContent, CardContentProps as Mui4CardContentProps } from '@material-ui/core'
import { default as Mui5CardContent } from '@mui/material/CardContent'
import { forwardRef } from 'react'
import { useComponentVersion } from '../hooks'
import { OsCardVersion } from './Card'

export type CardContentProps = Mui4CardContentProps
/** @deprecated Use CardContentProps */
export type OsCardContentProps = CardContentProps

export const CardContent = forwardRef<HTMLDivElement, CardContentProps>((props, ref) => {
  const version = useComponentVersion('card')
  switch (version) {
    case OsCardVersion.V2:
      //@ts-ignore
      return <Mui5CardContent ref={ref} {...props} />

    default:
      return <Mui4CardContent ref={ref} {...props} />
  }
})
